import { render, staticRenderFns } from "./GenericCreateImage.vue?vue&type=template&id=3af8986e&scoped=true"
import script from "./GenericCreateImage.vue?vue&type=script&lang=js"
export * from "./GenericCreateImage.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=3af8986e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af8986e",
  null
  
)

export default component.exports